// extracted by mini-css-extract-plugin
module.exports = {"ScoreSelector":"ScoreSelector_ScoreSelector__1ykcc","ScoreTexts":"ScoreSelector_ScoreTexts__2ejbZ","ScoreSelectorContainer":"ScoreSelector_ScoreSelectorContainer__2e4mp"};